module.exports = __webpack_public_path__ + "static/media/defaultimg.a86098c9.svg";